import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { TableVariantContext } from './TableVariantContext.js';
import './TableCell.scss.js';

var TableCellType;
(function(TableCellType2) {
  TableCellType2["Default"] = "default";
  TableCellType2["Numeric"] = "numeric";
  TableCellType2["Centered"] = "centered";
})(TableCellType || (TableCellType = {}));
const bem = Bem.create("vai-table__cell");
function inHead(tableVariant) {
  return tableVariant && tableVariant.variant === "head";
}
function inBody(tableVariant) {
  return tableVariant && tableVariant.variant === "body";
}
const TableCell = ({ htmlId, className, children, component, dataTa, type, isSortable, scope: scopeProp, ...rest }) => {
  return /* @__PURE__ */ React.createElement(TableVariantContext.Consumer, null, (tableVariant) => {
    const id = Id.create(htmlId, ["simple table cell"]);
    const Component = inHead(tableVariant) ? "th" : component;
    const classes = addClass(bem.block((inHead(tableVariant) || component === "th") && "head", inBody(tableVariant) && "body", (type === TableCellType.Numeric || type === TableCellType.Centered) && type, isSortable && "sortable"), className);
    let scope = scopeProp;
    if (!scope && inHead(tableVariant)) {
      scope = "col";
    }
    return /* @__PURE__ */ React.createElement(Component, {
      id: id.toString(),
      className: classes,
      scope,
      "data-ta": dataTa,
      ...rest
    }, children);
  });
};
TableCell.defaultProps = {
  component: "td",
  dataTa: "vai-table-cell",
  type: TableCellType.Default,
  isSortable: false
};

export { TableCell, TableCellType, TableCell as default };
